import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import '../styles/Users.scss';
import { faSearch, faUser } from '@fortawesome/free-solid-svg-icons';
import { Accordion, Button, Form } from 'react-bootstrap';
import UniInput, { FormControlElement } from '../components/UniInput/UniInput';
import UniPagination from '../components/UniPagination/UniPagination';
import { ChangeEvent, useEffect, useState } from 'react';
import { useUserStore } from '../store/user';
import moment from 'moment';
import Skeleton from 'react-loading-skeleton';
import { useNavigate } from 'react-router-dom';
import { UserCustomerDto, getProfileToStr, getUsersCustomer } from '../services/userService';
import { UserStatus } from '../types/userStatus';
import UniModalUserEdit from '../components/UniModalUserEdit/UniModalUserEdit';
import UniModalUserNew from '../components/UniModalUserNew/UniModalUserNew';
import { useTranslation } from 'react-i18next';

type SearchForm = {
    search?: string,
    status?: string,
    materialCode?: string
};

const Users = () => {
    const [usersCustomers, setUserCustomer] = useState<UserCustomerDto[]>();
    const [userCustomerEdit, setUserToEdit] = useState<UserCustomerDto>();
    const [showUserModal, setShowUserModal] = useState(false);
    const [showNewUserModal, setShowNewUserModal] = useState(false);
    const [search, setSearch] = useState<SearchForm>();
    const [error, setError] = useState<string>();
    const [loading, setLoading] = useState<boolean>(true);
    const [totalPages, setTotalPages] = useState<number>();
    const [totalItems, setTotalItems] = useState<number>();
    const [take, setTake] = useState<any>(10);
    const [page, setPage] = useState<number>(1);
    const { loginData, darkMode } = useUserStore();
    const [reload, setReload] = useState(false);
    const navigate = useNavigate();
    const { i18n, t } = useTranslation();


    useEffect(() => {
        if (localStorage.getItem('tkn')) {
            getOrders();
        }
    }, [loginData.id, take, page, reload]);

    const getOrders = () => {
        setLoading(true);
        setError('');
        getUsersCustomer(take, page, search?.search ?? '', search?.status ?? '')
            .then(response => {
                if (!response.success) {
                    setError(response.error);
                }
                else {
                    console.log(response, 'response');
                    setUserCustomer(response.data);
                    setTotalItems(response.totalItems);
                    setTotalPages(response.totalPages);
                }
            })
            .catch(e => console.log(e))
            .finally(() => setLoading(false))
    }

    const mockDataTable = {
        headers: [
            {
                property: 'name',
                name: t('user.labelName'),
                isCheck: false,
                isName: true
            },
            {
                property: 'email',
                name: 'Email',
                isEmail: true
            },
            {
                property: 'profile',
                name: t('user.labelProfile'),
                isNumber: false,
                isProfile: true
            },
            {
                property: 'customers',
                name: t('user.client'),
                isCustomer: true,
            },
            {
                property: 'lastAccessAt',
                name: t('user.lastAccess'),
                isDate: true
            },
            {
                property: 'active',
                name: 'Status',
                isStatus: true
            },
            {
                property: 'actions',
                name: '',
                isAction: true
            },
        ]
    };

    const mockStatusStyle = [
        {
            name: UserStatus.Active,
            color: '#30c10c',
            bgColor: '#eefff2',
        },
        {
            name: UserStatus.Inactive,
            bgColor: '#FFEFEA',
            color: '#FF6636',
        }
    ];

    const onChangeSearch = (e: ChangeEvent<FormControlElement>) => {
        setSearch({ ...search, search: e?.target?.value });
    }

    const onChangeStatus = (e: ChangeEvent<HTMLSelectElement>) => {
        setSearch({ ...search, status: e?.target?.value });
    }

    // FUNCTION TO SEARCH USER WHEN ENTER KEY IS CLICKED
    const handleEnterKey = (event:any) => {
        if(event.key === 'Enter'){
            getOrders();
        }
    }

    return (
        <>
            <div className='my-orders-wrapper'>
                <div className='my-orders-header w-100'>
                    <div className='my-orders-header-i'>
                        <FontAwesomeIcon icon={faUser} color='#00FF3C' size='xl' />
                        <p>{t('users')}</p>
                    </div>
                    <Button variant='primary' onClick={() => setShowNewUserModal(true)}>
                        <FontAwesomeIcon style={{ paddingRight: '5px' }} icon={faUser} color='#00FF3C' size='xl' />
                        {t('user.newUser')}
                    </Button>
                </div>
                <div className='my-orders-search w-100'>
                    <div>
                        <UniInput
                            id='search'
                            placeholder={t('user.searchFields')}
                            label={t('user.search')}
                            type='text'
                            onChangeInput={(e) => onChangeSearch(e)}
                            enterKey={handleEnterKey}
                        />
                    </div>

                    <UniInput
                        id='status'
                        label='Status'
                        isSelect
                        defaultValue={''}
                        onChange={e => onChangeStatus(e)}
                    >
                        <option value={''}>{t('user.selectAll')}</option>
                        <option value={'true'}>{t('user.active')}</option>
                        <option value={'false'}>{t('user.inactive')}</option>
                    </UniInput>
                    <FontAwesomeIcon icon={faSearch} title='Buscar' onClick={() => getOrders()} />
                </div>
                <div className='w-100 d-flex justify-content-center'>
                    <div className='table-uni'>
                        <div>
                            <div className='table-header'>
                                {
                                    mockDataTable.headers.map(header => (
                                        <div key={header.name} style={header.isStatus ? {
                                            width: 60, textAlign: 'left'
                                        } : header.isAction ? { width: 70 } : {}}
                                            className={header.isCheck ? `check-header` : ``}>
                                            {
                                                header.isCheck ? (
                                                    <>
                                                        <Form.Check
                                                            type={'checkbox'}
                                                            id={`default-check`}
                                                        />
                                                    </>
                                                ) : (
                                                    <>
                                                        {header.name}
                                                    </>
                                                )
                                            }
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                        {
                            loading ? (
                                <Skeleton
                                    width={'100%'}
                                    height={400}
                                    duration={1}
                                    highlightColor={darkMode ? '#6c6b6b' : '#f5f5f5'}
                                    baseColor={darkMode ? '#021717' : '#ebebeb'} />
                            ) :
                                (
                                    error ? (<p className='w-100 text-center p-2'>{t('customerScreen.searchNotFound')}</p>) :
                                        <Accordion as={'div'}>
                                            {
                                                usersCustomers?.map((user: any, idx) => (
                                                    <Accordion.Item as={'div'} eventKey={idx.toString()} key={idx.toString()}>
                                                        <div className='item-header'>
                                                            {
                                                                mockDataTable.headers.map(header => {
                                                                    if (header.isStatus) {
                                                                        return (
                                                                            <div key={header.name} style={{ maxWidth: 60 }}>
                                                                                <div className='table-status' style={{ backgroundColor: user?.[header.property] ? mockStatusStyle[0].bgColor : mockStatusStyle[1].bgColor ?? '#fff', minWidth: 145 }}>
                                                                                    <span className='table-status-icon' style={{ backgroundColor: user?.[header.property] ? mockStatusStyle[0].color : mockStatusStyle[1].color ?? '#fff' }}></span>
                                                                                    <div className='w-100' style={{ fontSize: 11 }}>{user?.[header.property] ? t('user.active') : t('user.inactive')}</div>
                                                                                </div>
                                                                            </div>
                                                                        );
                                                                    }

                                                                    if (header.property === 'check') {
                                                                        return (
                                                                            <Form.Check
                                                                                type={'checkbox'}
                                                                                id={`default-check`}
                                                                            />
                                                                        );
                                                                    }

                                                                    if (header.isDate) {
                                                                        return (
                                                                            <div key={header.name}>{user?.[header.property] ? `${moment(user?.[header.property]).format('DD/MM/yyyy HH:mm')}H` : '-'}</div>
                                                                        )
                                                                    }

                                                                    if (header.isNumber) {
                                                                        return (
                                                                            <div key={header.name}>{Number(user?.[header.property])}</div>
                                                                        )
                                                                    }

                                                                    if (header.isProfile) {
                                                                        return (
                                                                            <div key={header.name} style={{textAlign:'end', maxWidth: 30 }}>{getProfileToStr(user?.[header.property])}</div>
                                                                        )
                                                                    }

                                                                    if (header.isCustomer) {
                                                                        return (
                                                                            <div key={header.name} >{
                                                                                user?.[header.property].map((c: any) => { return (<div style={{textAlign:'start',}}>{`${Number(c.issuer)} - ${c.issuerName?.length > 12 ? c.issuerName?.slice(0, 11)+'...' : c.issuerName}`}</div>) })
                                                                            }</div>
                                                                        )
                                                                    }

                                                                    if (header.isName) {
                                                                        return (
                                                                            <div key={header.name} style={{ maxWidth: 30 }} title={user?.[header.property]}>{user?.[header.property] ? user?.[header.property]?.length > 30 ? user?.[header.property]?.slice(0, 29) + '...' : user?.[header.property] : '-'}</div>
                                                                        )
                                                                    }
                                                                    
                                                                    if (header.isEmail) {
                                                                        return (
                                                                            <div key={header.name} style={{ maxWidth: 60 }} title={user?.[header.property]}>{user?.[header.property] ? user?.[header.property]?.length > 30 ? user?.[header.property]?.slice(0, 29) + '...' : user?.[header.property] : '-'}</div>
                                                                        )
                                                                    }

                                                                    if (header.property === 'actions') {
                                                                        return (<Button variant='outline' onClick={() => {
                                                                            setShowUserModal(true);
                                                                            setUserToEdit(user);
                                                                        }}>{t('user.labelEditUser')}</Button>);
                                                                    }


                                                                    return (
                                                                        <div key={header.name} title={user?.[header.property]}>{user?.[header.property] ? user?.[header.property]?.length > 10 ? user?.[header.property]?.slice(0, 23) + '...' : user?.[header.property] : '-'}</div>
                                                                    )
                                                                })
                                                            }
                                                        </div>
                                                    </Accordion.Item>
                                                ))
                                            }
                                        </Accordion>
                                )
                        }
                    </div>
                </div>
                {
                    <UniPagination totalItems={totalItems} totalPages={totalPages} changePage={(e) => setPage(e)} changeTake={(e) => { setPage(1); setTake(e) }} />
                }
            </div>
            <UniModalUserEdit userCustomer={userCustomerEdit} show={showUserModal} onHide={() => {
                setShowUserModal(false);
                setReload(!reload);
            }} />
            <UniModalUserNew show={showNewUserModal} onHide={() => {
                setShowNewUserModal(false);
                setReload(!reload);
            }} />
        </>
    );
}

export default Users;